import React, { ReactElement } from 'react';
import PanelDataSet from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/DataSet';

const PanelDataSetContainer = (): ReactElement => <PanelDataSet />;

export default PanelDataSetContainer;
